const mediaItems = [
  {
    title: '红桃视频 · 悬疑剧场特辑',
    desc: '烧脑悬疑佳作合集 · 高清',
    duration: '12部合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20abstract%20cinematic%20theme%20with%20dark%20shadowy%20gradients%2C%20film%20noir%20elements%2C%20suspenseful%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20movie%20poster%20style%2C%20warm%20dark%20tones%2C%20no%20text%2C%20no%20faces&width=600&height=340&seq=media-1&orientation=landscape',
    views: '128万次播放',
  },
  {
    title: '西瓜视频免费 · 动作大片月',
    desc: '肾上腺素飙升的视觉盛宴 · 超清',
    duration: '25部合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Action%20movie%20abstract%20theme%20with%20dynamic%20explosive%20orange%20and%20red%20gradients%2C%20cinematic%20motion%20elements%2C%20intense%20atmosphere%2C%20blockbuster%20film%20aesthetic%2C%20energetic%20composition%2C%20no%20text%2C%20no%20faces&width=600&height=340&seq=media-2&orientation=landscape',
    views: '96万次播放',
  },
  {
    title: '小蓝视频 · 动漫盛宴连播',
    desc: '7月新番全收录 · 双语字幕',
    duration: '18部合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20abstract%20theme%20with%20vibrant%20colorful%20energetic%20composition%2C%20Japanese%20animation%20aesthetic%2C%20dynamic%20manga%20elements%2C%20bright%20playful%20atmosphere%2C%20modern%20anime%20design%2C%20no%20text%2C%20no%20faces&width=600&height=340&seq=media-3&orientation=landscape',
    views: '85万次播放',
  },
  {
    title: '茄子视频 · 纪录片之旅',
    desc: 'BBC年度纪录片精选 · 4K',
    duration: '10部合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Documentary%20nature%20abstract%20theme%20with%20earth%20green%20and%20blue%20tones%2C%20cinematic%20landscape%20elements%2C%20professional%20documentary%20aesthetic%2C%20calm%20atmospheric%20composition%2C%20natural%20world%20feeling%2C%20no%20text%2C%20no%20faces&width=600&height=340&seq=media-4&orientation=landscape',
    views: '72万次播放',
  },
  {
    title: '芒果视频 · 综艺爆笑集锦',
    desc: '热门综艺精华片段 · 高清',
    duration: '36部合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20abstract%20theme%20with%20bright%20vibrant%20pink%20yellow%20tones%2C%20stage%20performance%20elements%2C%20festive%20atmosphere%2C%20colorful%20dynamic%20composition%2C%20fun%20energetic%20design%2C%20no%20text%2C%20no%20faces&width=600&height=340&seq=media-5&orientation=landscape',
    views: '156万次播放',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            精彩推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            精选视频合集推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            编辑精选优质内容合集，一键直达精彩观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-0.5 rounded-md bg-black/50 text-background-50 text-xs font-medium">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/30 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}